<template>
  <div>
    <header-admin-pages
            title="Общественные советы при ФОИВ"
            :counter="getBanners.length"
            :button="headerButton"/>
    <table>
      <tr>
        <td>Верхний баннер</td>
        <td>Нижний баннер</td>
        <td class="drop-icon"></td>
      </tr>
      <tr v-for="item in getBanners" :key="`itemBlock${item.id}`">
        <td>{{ item.top_banner ? item.top_banner.substring(0, 50) : item.top_banner }}</td>
        <td>{{ item.bottom_banner ? item.bottom_banner.substring(0, 50) : item.bottom_banner }}</td>
        <td class="drop-icon">
          <drop-list @clickItem="clickItem"
                     :id-item="item.id"
                     :edit-link="`/admin/public_council_banner/${item.id}/edit`"/>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeaderAdminPages from '@/components/Admin/HeaderAdminPages'
import DropList from '@/components/Admin/DropList'

export default {
  name: 'PublicCouncilBanners',

  data () {
    return {
      headerButton: {
        title: 'Добавить баннер',
        link: '/admin/public_council_banner/create'
      }
    }
  },

  created () {
    this.$store.dispatch('setBanners')
  },

  methods: {
    clickItem (value) {
      if (value.value === 'del') {
        const consent = confirm('Вы уверены, чтобы хотите удалить баннер?')
        if (consent) {
          this.$store.dispatch('deleteBanner', value.id)
        } else {
          this.$noty.warning('Удаление отменено')
        }
      }
    }
  },

  computed: {
    getBanners () {
      return this.$store.getters.getBanners
    }
  },

  components: {
    DropList,
    HeaderAdminPages
  }
}
</script>

<style scoped lang="scss">
  table{
    margin-top: 2rem;
    border-spacing: 0;
    border-collapse: collapse;

    tr{
      padding: 0;
      border-bottom: 1px solid #D5D6D9;

      td {
        max-width: 23%;
        font-size: .812rem;
        line-height: 154%;
        color: #1F3245;
        padding: 1.375rem 1.375rem 1.375rem 0;

        a {
          color: #246CB7;
        }

        img {
          cursor: pointer;
          width: 1.5rem;
          height: 1.5rem;
          object-fit: contain;
          object-position: center;
        }
      }

      &:first-of-type td{
        padding: 1rem 0;
        color: #5E686C;
      }
    }
  }
</style>
